// extracted by mini-css-extract-plugin
export var closeButton = "_kl-2";
export var closeButtonIcon = "_kl-3";
export var lightboxContent = "_kl-1";
export var lightboxOverlay = "_kl-0";